import * as dotObject from 'dot-object'
import URLParser from './url-parser.helper'

export const parseSearchUrl = (prefix: string) => {
  const params = URLParser.getParams()
  let filters = {} as any
  params.forEach((value, key) => {
    if (key.includes(prefix)) {
      filters[key.replace(prefix, '')] = value
    }
  })

  return filters
}

export const hasUrlFilters = () => {
  return Object.keys(parseSearchUrl('filter_')).length > 0
}

export const normalizeStringToObject = (key: string, value: string, currentSearch: Object) => {
  dotObject.str(key, value, currentSearch)
  return currentSearch
}

function deepen(key: string, value: any, currentSearch?: Object): Object {

  const values = value.replace(/%/g, '').split(' ')
  const partes = key.split(',');
  let obj = {};

  partes.forEach((parte, index) => {
    const caminho = parte.split('.');
    let temp = obj;
    for (let i = 0; i < caminho.length; i++) {
      const chave = caminho[i];
      if (!temp[chave]) {
        temp[chave] = {};
      }
      if (i === caminho.length - 1) {
        if (index === 0) {
          temp[chave] = `%${values[0]}%`;
        }
        else {
          temp[chave] = values.length > 1 ? `%${value.slice(values[0].length + 2)}` : `%${values[0]}%`;
        }

      }
      temp = temp[chave];

    }
  });
  const deepMerge = (target: any, source: any) => {
    Object.keys(source).forEach(key => {
      if (source[key] && typeof source[key] === 'object') {
        if (!target[key]) target[key] = {};
        deepMerge(target[key], source[key]);
      } else {
        target[key] = source[key];
      }
    });
  }

  if (currentSearch && Object.keys(currentSearch).length > 0) {
    deepMerge(currentSearch, obj);
    return currentSearch;
  } else {
    return obj;
  }
}
export const parseFilterToField = (filters: any, key: string, value: any, defaultSubmitOptions: any) => {
  let extras: any = {}
  if (!value) return extras

  if (key.includes('ilike') && !value.includes('{') && !value.includes('}')) {
    value = `%${value}%`
  }

  if (value.includes('{') && value.includes('}')) {
    try {
      value = JSON.parse(value)
    } catch { }
  }

  if (value === 'true' || value === 'false') {
    value = value === 'true'
  }

  if (key.includes('.')) {

    const keys = key.split('.')

    if (keys.length > 1) {
      const currentSearch = {
        ...defaultSubmitOptions.search || {},
        ...filters
      }
      // Safety copy hahahahahaha
      let normalized = { ...JSON.parse(JSON.stringify(currentSearch)) } as any
      normalized = key.includes(",") ? deepen(key, value, normalized) : normalizeStringToObject(key, value, normalized)
      extras = {
        ...extras,
        ...normalized
      }

    } else {
      let obj = {}

      keys.reduce((previousValue: any, currentValue: any, currentIndex: any, arr: any) => {
        return previousValue[currentValue] = (previousValue[currentValue] || (arr[currentIndex + 1] ? {} : filters[key]))
      }, obj)

      extras = {
        ...extras,
        ...obj
      }
    }

  } else {


    if (key.includes('ilike')) {
      extras[key] = `%${value}%`
    } else {
      extras[key] = value
    }
  }

  return extras
}

export const mountFiltersFromURL = (currentSearchOptions: any) => {
  const filters = parseSearchUrl('filter_')
  let result = {} as any

  Object.keys(filters).forEach(key => {
    const value = filters[key]

    // Parse filter field
    result = {
      ...result,
      ...parseFilterToField(result, key, value, currentSearchOptions)
    }
  })

  return result
}
